import {useMemo} from "react";
import {FACTION_CONFIGS} from "../../configs/factions";

export const useSortedFactionConfigs = (factions) => {
  return useMemo(() => {
    const availableById = new Map(factions.map((faction) => [faction.id, faction]));
    return [...FACTION_CONFIGS].sort((a, b) => {
      const aAvailable = availableById.get(a.id)?.isAvailable ? 1 : 0;
      const bAvailable = availableById.get(b.id)?.isAvailable ? 1 : 0;
      if (aAvailable === bAvailable) return 0;
      return bAvailable - aAvailable;
    }).map((faction) => ({
      ...faction,
      isAvailable: Boolean(availableById.get(faction.id)?.isAvailable),
    }));
  }, [factions]);
}